import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {getMyMember} from '@wix/ambassador-members-v1-member/http'
import {Member, Set} from '@wix/ambassador-members-v1-member/types'

import {getDataFromMemoryCache, setDataToMemoryCache} from '../utils/dataCapsule'

const CACHE_KEY = 'tr-currentMember'

export const getCurrentMember = async (flowAPI: ControllerFlowAPI) => {
  const cachedCurrentMember = getDataFromMemoryCache<Member>(flowAPI, CACHE_KEY)
  const {getResolvedError, withErrorHandler} = flowAPI.errorHandler

  // If cached value is empty but not null
  // it means a previous request failed and user is not logged in
  if (cachedCurrentMember !== null) {
    return cachedCurrentMember || undefined
  }

  try {
    const currentMemberResponse = await withErrorHandler(
      () => flowAPI.httpClient.request(getMyMember({fieldsets: [Set.FULL]})),
      {
        errorCodesMap: {},
      },
    )
    setDataToMemoryCache(flowAPI, CACHE_KEY, currentMemberResponse.data?.member)
    return currentMemberResponse.data?.member
  } catch (error) {
    getResolvedError(error)
    // Set cache to empty string to signify that the request failed.
    setDataToMemoryCache(flowAPI, CACHE_KEY, '')
    return undefined
  }
}
